import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Container,
  InputGroupText,
  InputGroup
} from 'reactstrap';
import { connect } from 'react-redux';
import { loginAction, sendOTPAction } from '../../redux/auth/authAction';
import AppSpinnerWrapper from '../../componentsV2/common/AppSpinnerWrapper';
import { loadUserDetail } from '../../redux/userDetail/userDetailAction';
import { toast } from 'react-toastify';
import { isAuthenticated } from '../../utils';
import {
  sendAnalytics,
  ViewUserActivityAnalytics
} from '../../utils/analyticsUtils';
import '../../css/login.css';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import timerIcon from '../../image/icons/timer.svg';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  CorrectNumberIcon,
  IncorrectNumberIcon
} from '../../assets/icons/modifiedIcons';
import { isMobile } from 'react-device-detect';

function OTPLogin({
  loginAction,
  sendOTPAction,
  loading,
  mobileno,
  loadUserDetail
}) {
  const [otp, setOTP] = useState('');
  const [loader, setLoader] = useState(false);
  const [counter, setCounter] = useState(30);

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const [head, tail] = split(mobileno.substring(3), 5);

  function handleChange(event) {
    const { value } = event.target;
    setOTP(value);
  }
  function split(str, index) {
    const result = [str?.slice(0, index), str?.slice(index)];
    return result;
  }
  const SubmitOTP = e => {
    e.preventDefault();
    loginAction(otp)
      .then(loadUserDetail)
      .then(userDetail => {
        var UserName_Id = `${userDetail.name}_${userDetail.id}`;
        ViewUserActivityAnalytics(UserName_Id);
        toast.info(
          `Welcome ${userDetail.name} from ${userDetail.customer.company_name}...`,
          {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true
          }
        );

        const analytics_Details = {
          defaultName: 'OTP_LOGIN_SUCCESS',
          defaultDetails: `${otp} OTP Logged in & Redirect to Previous Page`
        };

        sendAnalytics(analytics_Details);
      })
      .catch(error => {
        toast.error('Invalid OTP, Please try again');

        const analytics_Details = {
          defaultName: 'OTP_LOGIN_ERROR',
          defaultDetails: `Some Error is there at time of Submit Contact. Error: ${error}`
        };

        sendAnalytics(analytics_Details);

        throw error;
      });
  };

  if (isAuthenticated() || !mobileno) {
    return <Navigate to='/login' />;
  }

  const resSendOTP = () => {
    sendOTPAction(mobileno)
      .then(() => {
        const analytics_Details = {
          defaultName: 'RESEND_OTP',
          defaultDetails: `Resend Otp to Mobile Number: ${mobileno}`
        };

        sendAnalytics(analytics_Details);

        toast.dark('OTP Send Successfully', {
          position: 'bottom-center',
          autoClose: 2000
        });
        setLoader(false);
      })
      .catch(err => {
        const analytics_Details = {
          defaultName: 'RESEND_OTP_ERROR',
          defaultDetails: `Some Error is there at the time of Resend OTP. Error ${err}`
        };

        sendAnalytics(analytics_Details);

        throw err;
      });
  };
  if (loader || loading) return <AppSpinnerWrapper />;
  return (
    <div className={isMobile ? 'relpos-otp-mob ' : 'relpos-otp'}>
      <div className='otp-form-animation'>
        <Form autoComplete='off' onSubmit={SubmitOTP}>
          <div
            className='textcenter'
            style={{
              marginBottom: '25px'
            }}
          >
            <div className='OTPtext'>Enter 4-digit code sent to </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className='mobStyle'>+91 {head + ' ' + tail}</span>
              <div
                className='edit-primary-color'
                onClick={() => {
                  window.location.href = '/login';
                }}
                style={{
                  cursor: 'pointer',
                  paddingLeft: '5px',
                  fontWeight: 700
                }}
              >
                <BorderColorIcon sx={{ fontSize: '16px' }} />
                Edit
              </div>
            </div>
          </div>
          <FormGroup>
            <div className='OTP'>OTP</div>
            <InputGroup>
              <Input
                value={otp}
                type='number'
                name='OTP'
                id='mobInput'
                autoComplete='one-time-code'
                inputMode='numeric'
                autoFocus
                placeholder='0000'
                onChange={handleChange}
                maxLength='6'
                className='formInput'
              />
              <InputGroupText className='mob-end'>
                {otp.length == 4 ? (
                  <CorrectNumberIcon />
                ) : (
                  <IncorrectNumberIcon />
                )}
              </InputGroupText>
            </InputGroup>
          </FormGroup>

          <span
            className=' transparentButton'
            style={{
              color: counter == 0 ? '#217EC0' : '#AAAAAA',
              cursor: counter == 0 ? 'pointer' : 'default',
              fontSize: '12px',
              paddingLeft: counter == 0 ? '275px' : '234px'
            }}
            disabled={!(counter == 0)}
            onClick={
              !(counter == 0)
                ? null
                : () => {
                    resSendOTP(), setCounter(30);
                  }
            }
          >
            {!(counter == 0) ? (
              <b>
                <img src={timerIcon} style={{ marginBottom: '4px' }} />{' '}
                {counter}s. Resend OTP
              </b>
            ) : (
              <b>Resend OTP</b>
            )}{' '}
          </span>

          <div className='textCenter'>
            <Button
              size='medium'
              disabled={otp.length < 4}
              className='otp-btn'
              style={{
                backgroundColor: otp.length == 4 ? '#217EC0' : ' #AAAAAA',
                fontWeight: 700
              }}
              disable={otp == '' ? 'true' : 'false'}
            >
              Login
              <ArrowForwardIcon />
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    Loading: state.apiCallsInProgress > 0,
    mobileno: state.auth.mobileno,
    userDetail: state.userDetail
  };
}

const mapDispatchtoProps = {
  loginAction,
  sendOTPAction,
  loadUserDetail
};

export default connect(mapStateToProps, mapDispatchtoProps)(OTPLogin);
